// Generated by purs version 0.15.16
import * as App_Browser from "../App.Browser/index.js";
import * as App_Hydrate from "../App.Hydrate/index.js";
import * as App_Msg from "../App.Msg/index.js";
import * as App_Operation_Runner from "../App.Operation.Runner/index.js";
import * as App_Operation_Store from "../App.Operation.Store/index.js";
import * as App_Operation_Types from "../App.Operation.Types/index.js";
import * as App_Route from "../App.Route/index.js";
import * as App_State from "../App.State/index.js";
import * as App_Step from "../App.Step/index.js";
import * as App_Step3DocumentRequest from "../App.Step3DocumentRequest/index.js";
import * as App_Update from "../App.Update/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React from "../Concur.React/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as $$Error from "../Error/index.js";
import * as Form_StudentSelect from "../Form.StudentSelect/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_JSUtil from "../Internal.JSUtil/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Steps_FormPicker from "../Steps.FormPicker/index.js";
import * as Steps_FormPreview from "../Steps.FormPreview/index.js";
import * as Steps_Step1_State from "../Steps.Step1.State/index.js";
import * as Steps_Step1_View from "../Steps.Step1.View/index.js";
import * as Steps_Step3_Scroll from "../Steps.Step3.Scroll/index.js";
import * as Steps_Step3_State from "../Steps.Step3.State/index.js";
import * as Steps_Step3_Transition from "../Steps.Step3.Transition/index.js";
import * as Steps_Step3_Update from "../Steps.Step3.Update/index.js";
import * as Steps_Step3_View from "../Steps.Step3.View/index.js";
import * as Steps_WorkQueue_DocumentIndex from "../Steps.WorkQueue.DocumentIndex/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
import * as Widgets_Form_Access from "../Widgets.Form.Access/index.js";
import * as Widgets_Form_TestForm from "../Widgets.Form.TestForm/index.js";
import * as Widgets_Loading from "../Widgets.Loading/index.js";
var nub = /* #__PURE__ */ Data_Array.nub(/* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString));
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var when = /* #__PURE__ */ Control_Applicative.when(Effect.applicativeEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var discard2 = /* #__PURE__ */ discard(Concur_Core_Types.bindWidget);
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(/* #__PURE__ */ Concur_Core_Types.monadEffectWidget(Data_Monoid.monoidArray));
var traverse_ = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Effect_Aff.monoidCanceler);
var map1 = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var alt = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Concur_Core_Types.altWidget(Data_Monoid.monoidArray));
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Widgets_Form_Access.encodeFieldAccessLevel);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons2 = /* #__PURE__ */ gEncodeJsonCons1(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var accessIsSymbol = {
    reflectSymbol: function () {
        return "access";
    }
};
var gEncodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean);
var gEncodeJsonCons4 = /* #__PURE__ */ gEncodeJsonCons3(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var deleteIsSymbol = {
    reflectSymbol: function () {
        return "delete";
    }
};
var gEncodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Internal_Luxon.encodeLDT);
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var gEncodeJsonCons6 = /* #__PURE__ */ gEncodeJsonCons2(nameIsSymbol)();
var gEncodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons6)());
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var created_atIsSymbol = {
    reflectSymbol: function () {
        return "created_at";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var updateIsSymbol = {
    reflectSymbol: function () {
        return "update";
    }
};
var gEncodeJsonCons8 = /* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons4(updateIsSymbol)());
var commentIsSymbol = {
    reflectSymbol: function () {
        return "comment";
    }
};
var gEncodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString));
var updated_atIsSymbol = {
    reflectSymbol: function () {
        return "updated_at";
    }
};
var encodeRecord = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(gEncodeJsonCons6)(idIsSymbol)())();
var gEncodeJsonCons10 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(encodeRecord));
var gEncodeJsonCons11 = /* #__PURE__ */ gEncodeJsonCons1(gEncodeJsonCons6);
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var gEncodeJsonCons12 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Internal_Luxon.encodeLDT));
var encodeRecord1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons2(labelIsSymbol)())(idIsSymbol)())();
var gEncodeJsonCons13 = /* #__PURE__ */ gEncodeJsonCons2(urlIsSymbol)();
var createIsSymbol = {
    reflectSymbol: function () {
        return "create";
    }
};
var semesterIsSymbol = {
    reflectSymbol: function () {
        return "semester";
    }
};
var gEncodeJsonCons14 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString));
var gEncodeJsonCons15 = /* #__PURE__ */ gEncodeJsonCons9(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var relationshipIsSymbol = {
    reflectSymbol: function () {
        return "relationship";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var emailIsSymbol = {
    reflectSymbol: function () {
        return "email";
    }
};
var contactIsSymbol = {
    reflectSymbol: function () {
        return "contact";
    }
};
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons2({
    reflectSymbol: function () {
        return "field";
    }
})())(accessIsSymbol)())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "fields";
    }
})())({
    reflectSymbol: function () {
        return "default";
    }
})())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons4(deleteIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons7(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "user";
    }
})())(urlIsSymbol)())({
    reflectSymbol: function () {
        return "path";
    }
})())(idIsSymbol)())({
    reflectSymbol: function () {
        return "description";
    }
})())(created_atIsSymbol)())(canIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons8({
    reflectSymbol: function () {
        return "private_comment";
    }
})())({
    reflectSymbol: function () {
        return "lock";
    }
})())(deleteIsSymbol)())({
    reflectSymbol: function () {
        return "create_employers";
    }
})())({
    reflectSymbol: function () {
        return "copy";
    }
})())(commentIsSymbol)())({
    reflectSymbol: function () {
        return "attach";
    }
})())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons7(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons8(deleteIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons5(Data_Argonaut_Encode_Class.gEncodeJsonNil)(updated_atIsSymbol)())({
    reflectSymbol: function () {
        return "public";
    }
})())(idIsSymbol)())(created_atIsSymbol)())(commentIsSymbol)())(canIsSymbol)())({
    reflectSymbol: function () {
        return "author";
    }
})())()))(/* #__PURE__ */ gEncodeJsonCons10(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons11(labelIsSymbol)())(idIsSymbol)())()))(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encodeRecord))(/* #__PURE__ */ gEncodeJsonCons12(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encodeRecord1))(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "positions";
    }
})())(idIsSymbol)())({
    reflectSymbol: function () {
        return "deleted_at";
    }
})())({
    reflectSymbol: function () {
        return "contacts";
    }
})())({
    reflectSymbol: function () {
        return "company";
    }
})())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(gEncodeJsonCons13)(labelIsSymbol)())({
    reflectSymbol: function () {
        return "format";
    }
})())()))(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJson)(/* #__PURE__ */ gEncodeJsonCons12(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons2(updateIsSymbol)())(deleteIsSymbol)())(createIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(encodeRecord1))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons2(semesterIsSymbol)())(nameIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons4({
    reflectSymbol: function () {
        return "useDefault";
    }
})())(updateIsSymbol)())({
    reflectSymbol: function () {
        return "saveDefault";
    }
})())({
    reflectSymbol: function () {
        return "request";
    }
})())(createIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons15(relationshipIsSymbol)())(labelIsSymbol)())(keyIsSymbol)())({
    reflectSymbol: function () {
        return "emailLabel";
    }
})())({
    reflectSymbol: function () {
        return "default_last_name";
    }
})())({
    reflectSymbol: function () {
        return "default_first_name";
    }
})())({
    reflectSymbol: function () {
        return "default_email";
    }
})())(canIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons2({
    reflectSymbol: function () {
        return "last_name";
    }
})())({
    reflectSymbol: function () {
        return "first_name";
    }
})())(emailIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons9(gEncodeJsonCons13)(relationshipIsSymbol)())(keyIsSymbol)())(idIsSymbol)())(created_atIsSymbol)())(contactIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons12(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons11({
    reflectSymbol: function () {
        return "color";
    }
})())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "tags";
    }
})())({
    reflectSymbol: function () {
        return "preferred_name";
    }
})())(nameIsSymbol)())({
    reflectSymbol: function () {
        return "last_imported_at";
    }
})())(idIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons10(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons15(keyIsSymbol)())(emailIsSymbol)())(commentIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons2({
    reflectSymbol: function () {
        return "link";
    }
})())(idIsSymbol)())({
    reflectSymbol: function () {
        return "data";
    }
})())(created_atIsSymbol)())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "verifications";
    }
})())(updated_atIsSymbol)())({
    reflectSymbol: function () {
        return "teacher";
    }
})())({
    reflectSymbol: function () {
        return "student";
    }
})())({
    reflectSymbol: function () {
        return "signatures";
    }
})())({
    reflectSymbol: function () {
        return "signature_fields";
    }
})())(semesterIsSymbol)())({
    reflectSymbol: function () {
        return "position";
    }
})())({
    reflectSymbol: function () {
        return "mutations";
    }
})())({
    reflectSymbol: function () {
        return "locked_at";
    }
})())({
    reflectSymbol: function () {
        return "json";
    }
})())(idIsSymbol)())({
    reflectSymbol: function () {
        return "formName";
    }
})())({
    reflectSymbol: function () {
        return "formId";
    }
})())({
    reflectSymbol: function () {
        return "exports";
    }
})())({
    reflectSymbol: function () {
        return "employer";
    }
})())(created_atIsSymbol)())({
    reflectSymbol: function () {
        return "courses";
    }
})())(contactIsSymbol)())({
    reflectSymbol: function () {
        return "comments";
    }
})())(canIsSymbol)())({
    reflectSymbol: function () {
        return "attachments";
    }
})())(accessIsSymbol)())());
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_Core_Types.functorWidget);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var div$prime = /* #__PURE__ */ Concur_React_DOM["div$prime"](/* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray))(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var step3RouteForState = function (locationState) {
    return function (ready) {
        var step3DocIds = nub(append(map(function (v) {
            return v.id;
        })(ready.editor.workQueueState.editDocs))(map(function (v) {
            return v.id;
        })(fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(ready.editor.workQueueState.documents)))));
        return new App_Route.RStep3({
            preservedQuery: App_Route.preserveQuery(locationState.search),
            activeDoc: new Data_Maybe.Just(ready.editor.fillState.doc.id),
            docs: step3DocIds,
            section: ready.editor.sectionIntent
        });
    };
};
var step1SearchDebounceDelay = 300.0;
var enqueue = function (mailbox) {
    return function (msgs) {
        return function __do() {
            var state = Effect_Ref.read(mailbox)();
            var v = Data_Array.uncons(append(state.queue)(msgs));
            if (state.waiter instanceof Data_Maybe.Just && v instanceof Data_Maybe.Just) {
                Effect_Ref.write({
                    queue: v.value0.tail,
                    waiter: Data_Maybe.Nothing.value
                })(mailbox)();
                return state.waiter.value0.wake(v.value0.head)();
            };
            return Effect_Ref.write({
                waiter: state.waiter,
                queue: append(state.queue)(msgs)
            })(mailbox)();
        };
    };
};
var runCommand = function (mailbox) {
    return function (state) {
        return function (v) {
            if (v instanceof App_Update.SyncRoute) {
                return function __do() {
                    var locationState = App_Browser.readLocation(state.pushStateInterface)();
                    var route = App_Route.routeForStepAndWorkQueueState(locationState)(state.step)(state.workQueueState);
                    Effect_Console.log("APP_SYNC_ROUTE " + App_Route.routeUrl(route))();
                    if (v.value0 instanceof App_State.PushRouteHistory) {
                        return App_Browser.pushRoute(state.pushStateInterface)(route)();
                    };
                    if (v.value0 instanceof App_State.ReplaceRouteHistory) {
                        return App_Browser.replaceRoute(state.pushStateInterface)(route)();
                    };
                    throw new Error("Failed pattern match at App.Runtime (line 259, column 9 - line 261, column 79): " + [ v.value0.constructor.name ]);
                };
            };
            if (v instanceof App_Update.HydrateLocation) {
                return Effect_Aff.launchAff_(bind1(App_Hydrate.deriveAppState(state)(v.value1))(function (hydrated) {
                    return liftEffect(enqueue(mailbox)([ new App_Msg.HydratedLocation(v.value0, v.value1, hydrated) ]));
                }));
            };
            if (v instanceof App_Update.RunStep1InitialLoad) {
                return App_Operation_Runner.runStep1InitialLoad(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.DebounceStep1Search) {
                return Effect_Aff.launchAff_(bind1(Effect_Aff.delay(step1SearchDebounceDelay))(function () {
                    return liftEffect(enqueue(mailbox)([ new App_Msg.Step1SearchDebounced(v.value0) ]));
                }));
            };
            if (v instanceof App_Update.RunStep1Search) {
                return App_Operation_Runner.runStep1Search(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep1PageChange) {
                return App_Operation_Runner.runStep1PageChange(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.RunStep1CurrentPageReload) {
                return App_Operation_Runner.runStep1CurrentPageReload(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep1SaveFormOrder) {
                return App_Operation_Runner.runStep1SaveFormOrder(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep1ToggleLocks) {
                return App_Operation_Runner.runStep1ToggleLocks(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep1CopyDocuments) {
                return App_Operation_Runner.runStep1CopyDocuments(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.RunStep1DeleteDocuments) {
                return App_Operation_Runner.runStep1DeleteDocuments(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep1ExportDocuments) {
                return App_Operation_Runner.runStep1ExportDocuments(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.RunStep1RequestSignatures) {
                return App_Operation_Runner.runStep1RequestSignatures(enqueue(mailbox))(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep1UpdateForms) {
                return App_Operation_Runner.runStep1UpdateForms(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.RunStep2AInitialLoad) {
                return App_Operation_Runner.runStep2AInitialLoad(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.RunStep2BLoad) {
                return App_Operation_Runner.runStep2BLoad(enqueue(mailbox))(v.value0)(v.value1)(v.value2)(v.value3);
            };
            if (v instanceof App_Update.RunStep2ExportAll) {
                return App_Operation_Runner.runStep2ExportAll(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.RunStep3FormTypesLoad) {
                return App_Operation_Runner.runStep3FormTypesLoad(enqueue(mailbox))(state)(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep3InitialLoad) {
                return App_Operation_Runner.runStep3InitialLoad(enqueue(mailbox))(state)(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.SyncStep3Route) {
                if (state.step3 instanceof App_State.Step3Ready) {
                    return function __do() {
                        var locationState = App_Browser.readLocation(state.pushStateInterface)();
                        var route = step3RouteForState(locationState)(state.step3.value0);
                        var currentUrl = locationState.pathname + (locationState.search + locationState.hash);
                        var nextUrl = App_Route.routeUrl(route);
                        when(nextUrl !== currentUrl)((function () {
                            if (v.value0 instanceof Steps_Step3_Transition.PushStep3History) {
                                return App_Browser.pushRoute(state.pushStateInterface)(route);
                            };
                            if (v.value0 instanceof Steps_Step3_Transition.ReplaceStep3History) {
                                return App_Browser.replaceRoute(state.pushStateInterface)(route);
                            };
                            throw new Error("Failed pattern match at App.Runtime (line 328, column 17 - line 330, column 87): " + [ v.value0.constructor.name ]);
                        })())();
                        if (state.step3.value0.editor.sectionIntent instanceof App_Route.SectionSet) {
                            return Steps_Step3_Scroll.scrollSectionIntoView(state.step3.value0.editor.sectionIntent.value0)();
                        };
                        return Data_Unit.unit;
                    };
                };
                return pure(Data_Unit.unit);
            };
            if (v instanceof App_Update.ScrollStep3Section) {
                return Steps_Step3_Scroll.scrollSectionIntoView(v.value0);
            };
            if (v instanceof App_Update.SaveStep3) {
                return App_Operation_Runner.runSaveStep3(enqueue(mailbox))(state)(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.LoadStep3) {
                return App_Operation_Runner.runLoadStep3(enqueue(mailbox))(state)(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.AutofillStep3) {
                return App_Operation_Runner.runAutofillStep3(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.ToggleStep3Lock) {
                return App_Operation_Runner.runToggleStep3Lock(enqueue(mailbox))(state)(v.value0)(v.value1);
            };
            if (v instanceof App_Update.RunStep3DocumentMutation) {
                return App_Operation_Runner.runStep3DocumentMutation(enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            };
            if (v instanceof App_Update.ConfirmStep3Cancel) {
                return function __do() {
                    var confirmed = Internal_JSUtil.manualSavePrompt();
                    return enqueue(mailbox)([ new App_Msg.Step3Msg(new Steps_Step3_Update.ConfirmCancelResult(confirmed)) ])();
                };
            };
            if (v instanceof App_Update.AllowPageUnload) {
                return Internal_JSUtil.allowPageUnload;
            };
            if (v instanceof App_Update.BlockPageUnload) {
                return Internal_JSUtil.blockPageUnload;
            };
            if (v instanceof App_Update.OpenExportUrl) {
                return function __do() {
                    var win = Web_HTML.window();
                    return $$void(Web_HTML_Window.open(v.value0)("_blank")("")(win))();
                };
            };
            if (v instanceof App_Update.OpenExternalUrl) {
                return function __do() {
                    var win = Web_HTML.window();
                    return $$void(Web_HTML_Window.open(v.value0)("_blank")("")(win))();
                };
            };
            if (v instanceof App_Update.ReportError) {
                return $$void($$Error.reportError(v.value0));
            };
            throw new Error("Failed pattern match at App.Runtime (line 254, column 28 - line 374, column 31): " + [ v.constructor.name ]);
        };
    };
};
var interpretCommands = function (mailbox) {
    return function (result) {
        return discard2(liftEffect1(traverse_(runCommand(mailbox)(result.state))(result.commands)))(function () {
            return pure1(result.state);
        });
    };
};
var dequeue = function (mailbox) {
    var step = function (state) {
        var v = Data_Array.uncons(state.queue);
        if (v instanceof Data_Maybe.Nothing) {
            return {
                state: state,
                value: Data_Maybe.Nothing.value
            };
        };
        if (v instanceof Data_Maybe.Just) {
            return {
                state: {
                    waiter: state.waiter,
                    queue: v.value0.tail
                },
                value: new Data_Maybe.Just(v.value0.head)
            };
        };
        throw new Error("Failed pattern match at App.Runtime (line 407, column 18 - line 416, column 14): " + [ v.constructor.name ]);
    };
    return Effect_Ref["modify$prime"](step)(mailbox);
};
var dequeueIfCurrent = function (epoch) {
    return function (loopId) {
        return function (mailbox) {
            return function __do() {
                var current = Effect_Ref.read(epoch)();
                var $595 = current === loopId;
                if ($595) {
                    return dequeue(mailbox)();
                };
                return Data_Maybe.Nothing.value;
            };
        };
    };
};
var clearWaiter = function (loopId) {
    return function (mailbox) {
        var clear = function (state) {
            if (state.waiter instanceof Data_Maybe.Just && state.waiter.value0.loopId === loopId) {
                return {
                    queue: state.queue,
                    waiter: Data_Maybe.Nothing.value
                };
            };
            return state;
        };
        return Effect_Ref.modify_(clear)(mailbox);
    };
};
var awaitMailboxMessage = function (epoch) {
    return function (loopId) {
        return function (mailbox) {
            return Concur_React.affAction(Effect_Aff.makeAff(function (reply) {
                return function __do() {
                    var current = Effect_Ref.read(epoch)();
                    var $598 = current !== loopId;
                    if ($598) {
                        return mempty;
                    };
                    var msgMaybe = dequeue(mailbox)();
                    if (msgMaybe instanceof Data_Maybe.Just) {
                        reply(new Data_Either.Right(msgMaybe.value0))();
                        return mempty;
                    };
                    if (msgMaybe instanceof Data_Maybe.Nothing) {
                        var wake = function (msg) {
                            return reply(new Data_Either.Right(msg));
                        };
                        Effect_Ref.modify_(function (v) {
                            return {
                                queue: v.queue,
                                waiter: new Data_Maybe.Just({
                                    loopId: loopId,
                                    wake: wake
                                })
                            };
                        })(mailbox)();
                        return Effect_Aff.effectCanceler(clearWaiter(loopId)(mailbox));
                    };
                    throw new Error("Failed pattern match at App.Runtime (line 212, column 13 - line 228, column 51): " + [ msgMaybe.constructor.name ]);
                };
            }));
        };
    };
};
var awaitLocationChange = function (v) {
    return Effect_Aff.makeAff(function (reply) {
        return function __do() {
            var unlisten = App_Browser.listenBrowserNavigation(function (locationState) {
                return reply(new Data_Either.Right(locationState));
            })();
            return Effect_Aff.effectCanceler(unlisten);
        };
    });
};
var awaitBrowserLocationChange = function (pushStateInterface) {
    return map1(App_Msg.BrowserLocationChanged.create)(Concur_React.affAction(awaitLocationChange(pushStateInterface)));
};
var nextMsgWidget = function (renderApp) {
    return function (epoch) {
        return function (loopId) {
            return function (mailbox) {
                return function (state) {
                    var baseSources = alt(renderApp(state))(alt(awaitBrowserLocationChange(state.pushStateInterface))(awaitMailboxMessage(epoch)(loopId)(mailbox)));
                    var awaitStep3DocumentRequest = function (ready) {
                        var currentDocJson = Data_Argonaut_Core.stringify(encodeJson(ready.editor.fillState.doc));
                        return voidRight(App_Msg.Step3DocumentRequestHandled.value)(Concur_React.affAction(App_Step3DocumentRequest.awaitRequest(currentDocJson)));
                    };
                    var awaitCurrentLoop = function (widget) {
                        return bind2(widget)(function (msg) {
                            return bind2(liftEffect1(Effect_Ref.read(epoch)))(function (current) {
                                var $601 = current === loopId;
                                if ($601) {
                                    return pure1(msg);
                                };
                                return awaitCurrentLoop(widget);
                            });
                        });
                    };
                    return bind2(liftEffect1(dequeueIfCurrent(epoch)(loopId)(mailbox)))(function (queued) {
                        if (queued instanceof Data_Maybe.Just) {
                            return pure1(queued.value0);
                        };
                        if (queued instanceof Data_Maybe.Nothing) {
                            return awaitCurrentLoop((function () {
                                if (state.step3 instanceof App_State.Step3Ready) {
                                    return alt(baseSources)(awaitStep3DocumentRequest(state.step3.value0));
                                };
                                return baseSources;
                            })());
                        };
                        throw new Error("Failed pattern match at App.Runtime (line 88, column 5 - line 97, column 32): " + [ queued.constructor.name ]);
                    });
                };
            };
        };
    };
};
var runAppLoop = function (renderApp) {
    return function (epoch) {
        return function (mailbox) {
            return function (rawState) {
                return bind2(liftEffect1(Effect_Ref.modify(function (v) {
                    return v + 1 | 0;
                })(epoch)))(function (loopId) {
                    return bind2(nextMsgWidget(renderApp)(epoch)(loopId)(mailbox)(rawState))(function (msg) {
                        return bind2($$Error.wrapCritical(App_Update.update(rawState)(msg)))(function (result) {
                            return bind2(interpretCommands(mailbox)(result))(function (nextState) {
                                return runAppLoop(renderApp)(epoch)(mailbox)(nextState);
                            });
                        });
                    });
                });
            };
        };
    };
};
var appMessageWidget = function (renderOptions) {
    return function (state) {
        if (state.step instanceof App_Step.Step1) {
            if (state.step1 instanceof App_State.Step1Ready) {
                return map1(App_Msg.Step1Msg.create)(Steps_Step1_View.step1MessageWidget((function () {
                    var $609 = App_Operation_Store.isScopeActive(state.operations)(App_Operation_Types.Step1GlobalScope.value);
                    if ($609) {
                        return Steps_Step1_State.startLoading(state.step1.value0);
                    };
                    return Steps_Step1_State.finishLoading(state.step1.value0);
                })()));
            };
            if (state.step1 instanceof App_State.Step1Loading) {
                return Widgets_Loading.loadingWidget;
            };
            if (state.step1 instanceof App_State.Step1NotLoaded) {
                return Widgets_Loading.loadingWidget;
            };
            throw new Error("Failed pattern match at App.Runtime (line 119, column 17 - line 129, column 26): " + [ state.step1.constructor.name ]);
        };
        if (state.step instanceof App_Step.Step2A) {
            if (state.step2A instanceof App_State.Step2AReady && App_Operation_Store.isScopeActive(state.operations)(App_Operation_Types.Step2ExportScope.value)) {
                return Steps_WorkQueue_View.loadingWidgetWQ(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            };
            if (state.step2A instanceof App_State.Step2AReady) {
                return map1(App_Msg.Step2AAction.create)(Form_StudentSelect.studentSelectStepWidget(state.workQueueState)(state.workQueueUi)(state.workQueueCache)(state.step2A.value0));
            };
            if (state.step2A instanceof App_State.Step2ALoading) {
                return Steps_WorkQueue_View.loadingWidgetWQ(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            };
            if (state.step2A instanceof App_State.Step2ALoadFailed) {
                return $$Error.handleCritical(state.step2A.value0);
            };
            if (state.step2A instanceof App_State.Step2ANotLoaded) {
                return Steps_WorkQueue_View.loadingWidgetWQ(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            };
            throw new Error("Failed pattern match at App.Runtime (line 131, column 18 - line 141, column 88): " + [ state.step2A.constructor.name ]);
        };
        if (state.step instanceof App_Step.Step2B) {
            if (state.step2B instanceof App_State.Step2BReady && App_Operation_Store.isScopeActive(state.operations)(App_Operation_Types.Step2ExportScope.value)) {
                return Steps_WorkQueue_View.loadingWidgetWQ(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            };
            if (state.step2B instanceof App_State.Step2BReady) {
                return map1(App_Msg.Step2BAction.create)(Steps_FormPicker.formPickerStepWidget(App_Route.routePreservedQuery(state.route))(state.step2B.value0));
            };
            if (state.step2B instanceof App_State.Step2BLoading) {
                return Steps_WorkQueue_View.loadingWidgetWQ(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            };
            if (state.step2B instanceof App_State.Step2BLoadFailed) {
                return $$Error.handleCritical(state.step2B.value0);
            };
            if (state.step2B instanceof App_State.Step2BNotLoaded) {
                return Steps_WorkQueue_View.loadingWidgetWQ(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            };
            throw new Error("Failed pattern match at App.Runtime (line 143, column 18 - line 153, column 88): " + [ state.step2B.constructor.name ]);
        };
        if (state.step3 instanceof App_State.Step3Ready && state.step instanceof App_Step.Step3) {
            return map1(function ($632) {
                return App_Msg.Step3Msg.create(Steps_Step3_Update.ViewEvent.create($632));
            })(Steps_Step3_View.renderStep3(renderOptions)(App_Route.routePreservedQuery(state.route))(state.step3.value0));
        };
        if (state.step3 instanceof App_State.Step3Ready && state.step instanceof App_Step.Step3Doc) {
            return map1(function ($633) {
                return App_Msg.Step3Msg.create(Steps_Step3_Update.ViewEvent.create($633));
            })(Steps_Step3_View.renderStep3(renderOptions)(App_Route.routePreservedQuery(state.route))(state.step3.value0));
        };
        if (state.step3 instanceof App_State.Step3LoadingFormTypes && state.step instanceof App_Step.Step3) {
            return Widgets_Loading.loadingWidget;
        };
        if (state.step3 instanceof App_State.Step3LoadingFormTypes && state.step instanceof App_Step.Step3Doc) {
            return Widgets_Loading.loadingWidget;
        };
        if (state.step3 instanceof App_State.Step3LoadingInitialState && state.step instanceof App_Step.Step3) {
            return Widgets_Loading.loadingWidget;
        };
        if (state.step3 instanceof App_State.Step3LoadingInitialState && state.step instanceof App_Step.Step3Doc) {
            return Widgets_Loading.loadingWidget;
        };
        if (state.step instanceof App_Step.Preview) {
            return voidRight(App_Msg.Step3DocumentRequestHandled.value)(Steps_FormPreview.previewWidget(state.step.value0));
        };
        if (state.step instanceof App_Step.TestForm) {
            return Widgets_Form_TestForm.renderTestForm;
        };
        if (state.step instanceof App_Step.Step4) {
            return div$prime([ text("") ]);
        };
        return Widgets_Loading.loadingWidget;
    };
};
var stepWidgetFromState = function (renderOptions) {
    return function (initial) {
        return bind2(liftEffect1(Effect_Ref["new"]({
            queue: [  ],
            waiter: Data_Maybe.Nothing.value
        })))(function (mailbox) {
            return bind2(liftEffect1(Effect_Ref["new"](0)))(function (epoch) {
                return bind2(interpretCommands(mailbox)(App_Update.bootstrap(initial)))(function (bootstrapped) {
                    return runAppLoop(appMessageWidget(renderOptions))(epoch)(mailbox)(bootstrapped);
                });
            });
        });
    };
};
var stepWidget = /* #__PURE__ */ bind2(/* #__PURE__ */ Control_Bind.bindFlipped(Concur_Core_Types.bindWidget)($$Error.wrapCritical)(App_Hydrate.loadAppStateWidget))(function (initial) {
    return stepWidgetFromState(Steps_Step3_State.defaultRenderOptions)(initial);
});
export {
    stepWidget,
    stepWidgetFromState
};
//# sourceMappingURL=index.js.map
